// @react
import React, { useEffect } from 'react'
import { RouteNamesExternal } from 'constants/routeNamesExternal'
// @components

/******************************************
 * TEMP ROUTE TO SHOW SOME UTILITY LINKS
 * FOR CLIENT UAT
 ******************************************/

const MyATD = () => {
  // @todo fix this hack
  useEffect(() => {
    console.log(process.env.REACT_APP_HOST_ENV)
    if (process.env.REACT_APP_HOST_ENV === 'PROD') {
      console.log('redirect')
      window.location.assign(RouteNamesExternal.ATD_HOME)
    }
  }, [])

  /******************************************
   * RENDER
   ******************************************/
  return <></>
}
export default MyATD
